import { createSlice } from '@reduxjs/toolkit';
import { RootState } from 'src/store';
import { Status as StatusTypes } from 'src/ts/enums';
import { IRejectedAction } from 'src/ts/interfaces';
import { NAME } from './constants';
import { getApplicationTrackingAccessThunk } from './services';

type ApplicationTrackingState = {
  allowed: boolean;
  status: StatusTypes;
  error?: string | null;
};

const initialState: ApplicationTrackingState = {
  allowed: false,
  status: StatusTypes.IDLE,
  error: null
};

const applicationTrackingSlice = createSlice({
  name: NAME,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getApplicationTrackingAccessThunk.pending, (state) => {
      state.status = StatusTypes.LOADING;
      state.error = null;
    });
    builder.addCase(
      getApplicationTrackingAccessThunk.rejected,
      (state, action: IRejectedAction) => {
        state.status = StatusTypes.ERROR;
        state.allowed = false;
        state.error = action.error?.message;
      }
    );
    builder.addCase(getApplicationTrackingAccessThunk.fulfilled, (state, action) => {
      state.status = StatusTypes.SUCCESS;
      state.allowed = action.payload?.allowed === true;
    });
  }
});

export const selectors = {
  allowed: (state: RootState) => state[NAME].allowed,
  status: (state: RootState) => state[NAME].status
};

export const { reducer } = applicationTrackingSlice;
